import { ChangeEvent, useEffect, useState } from 'react'
import { AvisosEmbudo } from './AvisosEmbudo'
import { SegInput } from '../../../SegUI/SegInput/SegInput'
import { SegTooltip } from '../../../SegUI/SegTooltip/SegTooltip'
import { SegFormEmisionContainer } from '../../../SegFormEmisionContainer/SegFormEmisionContainer'
import { SegButton } from '../../../SegUI/SegButton/SegButton'
import { useEmisionStore } from '../../../../Services/Providers/EmisionStore';
import { useNavigate } from 'react-router-dom'
import { getRubroFromPath } from '../../../../utils/getRubro'
import { Controller, FormProvider, SubmitHandler, useForm } from 'react-hook-form'
import { SegCoberturaInfo } from '../../../SegCoberturaInfo/SegCoberturaInfo';
import { useCotizacionStore } from '../../../../Services/Providers/CotizacionStore'
import { Link } from 'react-router-dom'
import styled from '@emotion/styled'
import { useCertificadoNoRodamiento } from './hooks/useCertificadoNoRodamiento'
import {
    obtenerProvincias,
    obtenerTiposInspeccion,
    informarPaso,
} from '../../../../Services/API/bff/auto'
import { camposDelFormulario, datosVehiculo } from '../../../../Services/API/bff/auto/embudo'
import { RechazoEmbudo } from './RechazoEmbudo'
import { autoViaBffDesdeConfig } from '../../../../Services/API/bff/auto/flag'
import { useConfig } from '../../../../context/ConfigContext'
import { validarVencimientoOblea } from '../../../../Services/API/bff/auto/emision'
import { interpretarAnio } from '../../../../Services/API/bff/auto/funnel'
import { idDeProvincia } from '../../../../Services/API/bff/auto/catalogoProvincias'
import { ICilindroGnc } from '../../../../Services/Providers/EmisionStore'
import { SegSelect, SegSelectOption } from '../../../SegUI/SegSelect/SegSelect'

const StyledLink = styled(Link)`
    padding: 10px;
    padding-left:25px;
    padding-right:25px;
    width: 100%;
    color: #2C7DFD;
    background-color: #ffffff;
    display: inline-block;
    font-size: 14px;
    font-weight: 700;
    line-height: 1;
    text-align: center;
    text-decoration: none;
    vertical-align: middle;
    -webkit-user-select: none;
    border: 0;
    border-radius: 5px;
`

interface IDatosAuto {
    patente: string;
    numMotor: string;
    numChasis: string;
    /* GNC (camino BFF, sólo si el vehículo tiene GNC) */
    gncNumeroOblea: string;
    gncVencimientoOblea: string;
    gncMarcaRegulador: string;
    gncNumeroRegulador: string;
    gncCil1Marca: string;
    gncCil1Numero: string;
    gncCil2Marca: string;
    gncCil2Numero: string;
    gncCil3Marca: string;
    gncCil3Numero: string;
    /* Inspección a domicilio (camino BFF, sólo si el tipo elegido lo pide) */
    inspDomLocalidad: string;
    inspDomCodigoPostal: string;
    inspDomCalle: string;
    inspDomAltura: string;
    inspDomFecha: string;
    inspDomHorarioDesde: string;
    inspDomHorarioHasta: string;
    inspDomCodigoArea: string;
    inspDomTelefono: string;
}

/** Los tres cilindros que acepta el BFF, con sus campos del formulario. */
const CILINDROS: Array<{
    etiqueta: string;
    marca: 'gncCil1Marca' | 'gncCil2Marca' | 'gncCil3Marca';
    numero: 'gncCil1Numero' | 'gncCil2Numero' | 'gncCil3Numero';
}> = [
    { etiqueta: '1', marca: 'gncCil1Marca', numero: 'gncCil1Numero' },
    { etiqueta: '2', marca: 'gncCil2Marca', numero: 'gncCil2Numero' },
    { etiqueta: '3', marca: 'gncCil3Marca', numero: 'gncCil3Numero' },
];

const INSPECCION_A_DOMICILIO = 'A-DOMICILIO';

export const DatosAuto = () => {

    const { emisionValues, setEmisionValues } = useEmisionStore();
    const { cotizacionValues } = useCotizacionStore();
    const { renderInputCertificadoNoRodamiento, validarCNR } = useCertificadoNoRodamiento({ es0km: (cotizacionValues.año?.value === "0 Km") ? true : false });
    const [esSinPatente, setEsSinPatente] = useState<boolean>((cotizacionValues.año?.value === "0 Km") ? true : false);
    const nav = useNavigate();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const esMoto = getRubroFromPath() === "moto";

    const { config: envConf } = useConfig();
    const viaBff = autoViaBffDesdeConfig(envConf);
    /**
     * Detalle de GNC: el checkbox "¿Tiene GNC?" se contesta en la revisión de
     * datos; acá se cargan la oblea, el regulador y los cilindros, que es lo
     * que pedía el formulario del monolito y el BFF acepta desde el 19/09/2026.
     */
    const mostrarGnc = viaBff && !!emisionValues.gnc;
    const [tiposInspeccion, setTiposInspeccion] = useState<SegSelectOption[]>([]);
    const [tipoInspeccion, setTipoInspeccion] = useState<SegSelectOption>();
    const [provinciasInspeccion, setProvinciasInspeccion] = useState<SegSelectOption[]>([]);
    const [provinciaInspeccion, setProvinciaInspeccion] = useState<SegSelectOption>();
    const inspeccionADomicilio =
        (tipoInspeccion?.value || '').toUpperCase() === INSPECCION_A_DOMICILIO;

    const { handleSubmit, control, setValue, formState, trigger, setError } = useForm<IDatosAuto>();
    /** Mensaje del 422 del embudo: el paso no avanza hasta corregir el dato. */
    const [rechazoEmbudo, setRechazoEmbudo] = useState<string>();
    const selects = useForm<IDatosAuto>();

    /** Vuelve a la pantalla con lo ya cargado (el paso se puede revisitar). */
    useEffect(() => {
        if (!viaBff) return;
        const detalle = emisionValues.gncDetalle;
        if (detalle) {
            setValue("gncNumeroOblea", detalle.numeroOblea || "");
            setValue("gncVencimientoOblea", detalle.vencimientoOblea || "");
            setValue("gncMarcaRegulador", detalle.marcaRegulador || "");
            setValue("gncNumeroRegulador", detalle.numeroRegulador || "");
            (detalle.cilindros || []).slice(0, CILINDROS.length).forEach((cilindro, indice) => {
                setValue(CILINDROS[indice].marca, cilindro.marca || "");
                setValue(CILINDROS[indice].numero, cilindro.numero || "");
            });
        }
        const inspeccion = emisionValues.inspeccion;
        if (inspeccion?.tipo) {
            setTipoInspeccion({ value: inspeccion.tipo, label: inspeccion.tipo });
        }
        const dom = inspeccion?.domicilio;
        setValue("inspDomLocalidad", dom?.localidad || emisionValues.localidad || "");
        setValue("inspDomCodigoPostal", dom?.codigoPostal || emisionValues.codigoPostal || "");
        setValue("inspDomCalle", dom?.calle || emisionValues.calle || "");
        setValue("inspDomAltura", dom?.altura || emisionValues.altura || "");
        setValue("inspDomFecha", dom?.fecha || "");
        setValue("inspDomHorarioDesde", dom?.horarioDesde || "");
        setValue("inspDomHorarioHasta", dom?.horarioHasta || "");
        setValue("inspDomCodigoArea", dom?.codigoArea || emisionValues.celular?.cod || "");
        setValue("inspDomTelefono", dom?.telefono || emisionValues.celular?.numero || "");
        if (cotizacionValues.provincia?.value) {
            setProvinciaInspeccion(cotizacionValues.provincia);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [viaBff]);

    /**
     * Tipos de inspección de la compañía elegida. Si el catálogo no devuelve
     * ninguno, la pantalla no muestra nada: la inspección la coordina la
     * compañía por su cuenta.
     */
    useEffect(() => {
        if (!viaBff) return;
        let vigente = true;
        const traer = async () => {
            const { anio, esCeroKm } = interpretarAnio(cotizacionValues.año?.value);
            try {
                const items = await obtenerTiposInspeccion(
                    emisionValues.cotizacionDesc?.codCompany || "",
                    anio,
                    esCeroKm,
                    getRubroFromPath()
                );
                if (!vigente) return;
                const opciones = items.map((item) => ({
                    value: item.codigo,
                    label: item.descripcion,
                }));
                setTiposInspeccion(opciones);
                setTipoInspeccion((actual) =>
                    actual
                        ? opciones.find((opcion) => opcion.value === actual.value) || actual
                        : actual
                );
            } catch {
                // Sin catálogo no se muestra el select: la inspección la coordina
                // la compañía. No es motivo para frenar la emisión.
                if (vigente) setTiposInspeccion([]);
            }
        };
        traer();
        return () => { vigente = false; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [viaBff, emisionValues.cotizacionDesc?.codCompany]);

    /** Provincias para el domicilio de la inspección. */
    useEffect(() => {
        if (!viaBff || !inspeccionADomicilio || provinciasInspeccion.length) return;
        let vigente = true;
        const traer = async () => {
            try {
                const nombres = await obtenerProvincias();
                if (!vigente) return;
                setProvinciasInspeccion(
                    nombres.map((nombre) => ({ value: nombre, label: nombre }))
                );
            } catch {
                if (vigente) setProvinciasInspeccion([]);
            }
        };
        traer();
        return () => { vigente = false; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [viaBff, inspeccionADomicilio]);

    const onSubmit: SubmitHandler<IDatosAuto> = async(values: IDatosAuto) => {
        const { patente, numMotor, numChasis } = values;

        const cilindros: ICilindroGnc[] = CILINDROS
            .map((cilindro) => ({
                marca: values[cilindro.marca],
                numero: values[cilindro.numero],
            }))
            .filter((cilindro) => cilindro.marca || cilindro.numero);

        const gncDetalle = mostrarGnc
            ? {
                numeroOblea: values.gncNumeroOblea,
                vencimientoOblea: values.gncVencimientoOblea,
                marcaRegulador: values.gncMarcaRegulador,
                numeroRegulador: values.gncNumeroRegulador,
                cilindros,
            }
            : emisionValues.gncDetalle;

        const inspeccion = tipoInspeccion?.value
            ? {
                tipo: tipoInspeccion.value,
                domicilio: inspeccionADomicilio
                    ? {
                        provinciaId: String(idDeProvincia(provinciaInspeccion?.value) || ""),
                        localidad: values.inspDomLocalidad,
                        codigoPostal: values.inspDomCodigoPostal,
                        calle: values.inspDomCalle,
                        altura: values.inspDomAltura,
                        fecha: values.inspDomFecha,
                        horarioDesde: values.inspDomHorarioDesde,
                        horarioHasta: values.inspDomHorarioHasta,
                        codigoArea: values.inspDomCodigoArea,
                        telefono: values.inspDomTelefono,
                    }
                    : undefined,
            }
            : emisionValues.inspeccion;

        const nuevosValores = {
            ...emisionValues,
            numMotor,
            numChasis,
            patente: esSinPatente ? "A/D" : patente.toUpperCase(),
            gncDetalle,
            inspeccion,
        };
        setEmisionValues(nuevosValores);

        setIsLoading(true);
        setRechazoEmbudo(undefined);
        const resultado = await informarPaso(4, {
            idItemCotizacion: emisionValues.cotizacionDesc!.id,
            NroMotor: numMotor,
            NroChasis: numChasis,
            Patente: patente,
            //datos anteriores
            Localidad: emisionValues.localidad,
            Calle: emisionValues.calle,
            NumeroCalle: emisionValues.altura,
            Piso: emisionValues.piso,
            Departamento: emisionValues.departamento,
            Nombre: emisionValues.nombre,
            Apellido: emisionValues.apellido,
            Email: emisionValues.email,
            NroDocumento: emisionValues.numDoc,
            Telefono: {
                CodigoArea: emisionValues.celular?.cod,
                Numero: emisionValues.celular?.numero,
                TelefonoEsCelular: true
            },
            Cuil: emisionValues.cuil,
            FechaNacimiento: `${emisionValues.fechaNac?.dia}/${emisionValues.fechaNac?.mes}/${emisionValues.fechaNac?.anio}`,
            TelefonoAdicional: {
                CodigoArea: emisionValues.telAdicional?.cod,
                Numero: emisionValues.telAdicional?.numero,
                TelefonoEsCelular: true
            },
            TipoDePersona: emisionValues.tipoPersona,
            CondicionIVA: emisionValues.condicionIva,
            TipoUso: emisionValues.tipoUso,
            TieneGNC: emisionValues.gnc
        }, undefined, { paso: 'vehiculo', datos: datosVehiculo(nuevosValores, cotizacionValues) })
        setIsLoading(false);
        if (resultado.frena) {
            const { mensaje, campos } = resultado.rechazo;
            camposDelFormulario('vehiculo', campos).forEach((campo) =>
                setError(campo as keyof IDatosAuto, { type: 'embudo', message: mensaje })
            );
            setRechazoEmbudo(mensaje);
            return;
        }
        nav(`/${getRubroFromPath()}/emision/datostarjeta`);
    }

    useEffect(() => {
        cotizacionValues.patente && setValue("patente", cotizacionValues.patente);
        cotizacionValues.patente && trigger("patente")
        emisionValues.numMotor ? setValue("numMotor", emisionValues.numMotor) : setValue("numMotor", "")
        emisionValues.numMotor && trigger("numMotor")
        emisionValues.numChasis ? setValue("numChasis", emisionValues.numChasis) : setValue("numChasis", "")
        emisionValues.numChasis && trigger("numChasis")

        if (cotizacionValues.patente === undefined) {
            if (cotizacionValues.año?.value === "0 Km") {
                const nroMotorInput = document.getElementById("nroMotor");
                if (nroMotorInput && nroMotorInput.tagName.toLowerCase() === "input") {
                    nroMotorInput.focus();
                }
            } else {
                const patenteInput = document.getElementById("patente");
                if (patenteInput && patenteInput.tagName.toLowerCase() === "input") {
                    patenteInput.focus();
                }
            }
        } else {
            const nroMotorInput = document.getElementById("nroMotor");
            if (nroMotorInput && nroMotorInput.tagName.toLowerCase() === "input") {
                nroMotorInput.focus();
            }
        }

    }, []);

    const handleSetEsSinPatente = async (e: ChangeEvent<HTMLInputElement>) => {
        setEsSinPatente(e.target.checked);
        setValue("patente", "");
        await new Promise(resolve => setTimeout(resolve, 0)); // Espera un ciclo de evento
        trigger("patente");
    }


    return (
        <div>
            <div className="px-20 pb-40 pb-lg-60 maxw-1170p mx-auto">
                {/* <div className="bg-gray-light py-lg-1 mb-3 mb-lg-2 rounded-5p"> */}
                <div className="d-lg-none">
                    <StyledLink to="" data-bs-target="#offcanvas" data-bs-toggle="collapse" className='btn1-md d-block fs-15 maxw-md-475p mx-md-auto' >Ver detalle de cobertura</StyledLink>
                </div>
                <div className="d-none d-lg-block">
                    <SegCoberturaInfo emisionValues={emisionValues} />
                </div>
                {/* <div className="d-none d-lg-flex align-items-center justify-content-center">
                        <span className="me-3 fs-16 fw-bold text-primary">Vehículo cotizado <span className="fs-20 fw-bold text-gray-dark">&gt;</span></span>
                        <div className="fs-16 fw-bold text-gray-aux">{cotizacionValues.marca?.label + " " + cotizacionValues.modelo?.label + " " + cotizacionValues.año?.label} | {cotizacionValues.version?.label} | <span className="fw-normal">Zona de guardado:</span> {cotizacionValues.localidad?.label}</div>
                    </div> */}
                {/* </div> */}
                {/* <SegCoberturaInfoEmision emisionValues={emisionValues} /> */}
                <form onSubmit={handleSubmit(onSubmit)}>
                    <AvisosEmbudo />
                    <SegFormEmisionContainer title={getRubroFromPath() === "moto" ? 'Datos de la moto' : 'Datos del auto'}>
                        <div className="col-md-4">
                            <Controller
                                name="patente"
                                control={control}
                                rules={{
                                    validate: {
                                        pattern: (value) => {
                                            if (esSinPatente) return true;
                                            // Auto: ABC123 (viejo) / AB123CD (Mercosur)
                                            // Moto: 123ABC (viejo) / A123BCD (Mercosur)
                                            const regexPatente = esMoto
                                                ? /^\d{3}[A-Za-z]{3}$|^[A-Za-z]\d{3}[A-Za-z]{3}$/
                                                : /^[A-Za-z]{3}\d{3}$|^[A-Za-z]{2}\d{3}[A-Za-z]{2}$/;
                                            return regexPatente.test(
                                                value
                                            ) || "Patente inválida"
                                        },
                                        required: (value) => {
                                            if (!esSinPatente) {
                                                return !!value || "Ingresá la patente";
                                            } else {
                                                return true
                                            }
                                        },

                                    },
                                }}
                                render={({ field, fieldState }) => (
                                    <div><label style={{ fontWeight: 'bold' }}>Patente </label>
                                        <SegInput
                                            className='mt-2'
                                            id='patente'
                                            placeHolder={esSinPatente ? "" : (esMoto ? "Ej: A123BCD" : "Ej: FUH384")}
                                            name="patente"
                                            type="text"
                                            width={100}
                                            onChange={(e) => {
                                                field.onChange(e);
                                                setValue("patente", e.target.value);
                                                trigger("patente");
                                            }}
                                            label=""
                                            value={field.value}
                                            leyendaError={fieldState?.error?.message}
                                            autoFocus={true}
                                            disabled={esSinPatente}
                                            borderColor={`${formState.errors.patente
                                                ? "var(--bs-form-invalid-border-color)"
                                                : ""
                                                }`}
                                            focusBorderColor={`${formState.errors.patente
                                                ? "var(--bs-form-invalid-border-color)"
                                                : "#2c7dfd"
                                                }`}
                                        />
                                    </div>
                                )}
                            />
                            {/* <SegInput label='Patente' name='patente' type='text' width={100} disabled={patenteDisabled} /> */}
                            {(cotizacionValues.año?.value === "0 Km") &&
                                <div className='d-flex align-items-center'>
                                    <input
                                        id='checkPatente'
                                        className='mx-2'
                                        type="checkbox"
                                        checked={esSinPatente}
                                        onChange={(e) => handleSetEsSinPatente(e)}
                                    />
                                    <label htmlFor='checkPatente' className="label-color" style={{ cursor: "pointer" }}>A declarar</label>
                                </div>
                            }
                        </div>
                        <div className="col-md-4">
                            <Controller
                                name="numMotor"
                                control={control}
                                rules={{
                                    validate: {
                                        required: (value) => !!value || "Ingresá Nro. de motor",
                                        withoutSpecialCaracters: (value) =>
                                            /^[a-zA-Z0-9]+$/.test(
                                                value
                                            ) || "No se permiten caracteres especiales.",
                                        min5: (value) => {
                                            if (value.length < 5) {
                                                return "Minimo 5 caracteres"
                                            }
                                            else {
                                                return true
                                            }
                                        },
                                    },
                                }}
                                render={({ field, fieldState }) => (
                                    // <div><label style={{ fontWeight: 'bold', display: 'flex', alignItems: 'center' }}>N° de motor <SegTooltip text="Lo encontrás en la cédula verde." /></label>
                                    <div><div style={{ fontWeight: 'bold', display: 'flex', alignItems: 'center' }}><label>N° de motor <SegTooltip placement={'top-start'} text="Lo encontrás en tu cédula verde o ingresando a la app Mi Argentina > Mis vehículos, o en el vehículo (grabado en motor)." /></label></div>
                                        <SegInput
                                            id="nroMotor"
                                            className='mt-2'
                                            placeHolder="Ej: CDJA48161179"
                                            name="numMotor"
                                            type="text"
                                            width={100}
                                            onChange={(e) => {
                                                field.onChange(e);
                                                setValue("numMotor", e.target.value); // Actualiza el valor en React Hook Form
                                                trigger("numMotor");
                                            }}
                                            label=""
                                            value={field.value}
                                            leyendaError={fieldState?.error?.message}
                                            autoFocus={true}

                                            borderColor={`${formState.errors.numMotor
                                                ? "var(--bs-form-invalid-border-color)"
                                                : ""
                                                }`}
                                            focusBorderColor={`${formState.errors.numMotor
                                                ? "var(--bs-form-invalid-border-color)"
                                                : "#2c7dfd"
                                                }`}
                                        />
                                    </div>
                                )}
                            />
                            {/* <SegInput label='N° de motor' name='numMotor' type='text' width={100} /> */}
                        </div>
                        <div className="col-md-4">
                            <Controller
                                name="numChasis"
                                control={control}
                                rules={{
                                    validate: {
                                        required: (value) => !!value || (esMoto ? "Ingresá Nro. de cuadro" : "Ingresá Nro. de chasis"),
                                        withoutSpecialCaracters: (value) =>
                                            /^[a-zA-Z0-9]+$/.test(
                                                value
                                            ) || "No se permiten caracteres especiales.",
                                        min5: (value) => {
                                            if (value.length < 5) {
                                                return "Minimo 5 caracteres"
                                            }
                                            else {
                                                return true
                                            }
                                        },
                                        max17: (value) => {
                                            if (value.length > 17) {
                                                return "Maximo 17 caracteres"
                                            }
                                            else {
                                                return true
                                            }
                                        },
                                    },
                                }}
                                render={({ field, fieldState }) => (
                                    <div>
                                        <label style={{ fontWeight: 'bold' }}>{esMoto ? 'N° de cuadro' : 'N° de chasis'} </label>
                                        <SegTooltip placement={'top-start'} text="Lo encontrás en tu cédula verde o ingresando a la app Mi Argentina > Mis vehículos, o en el vehículo (grabado en motor)." />
                                        <SegInput
                                            maxLenghtDigits={17}
                                            className='mt-2'
                                            placeHolder="Ej: 9BFZF16N748161179"
                                            name="numChasis"
                                            type="text"
                                            width={100}
                                            onChange={(e) => {
                                                field.onChange(e);
                                                setValue("numChasis", e.target.value); // Actualiza el valor en React Hook Form
                                                trigger("numChasis");
                                            }}
                                            label=""
                                            value={field.value}
                                            leyendaError={fieldState?.error?.message}
                                            autoFocus={true}
                                            borderColor={`${formState.errors.numChasis ? "var(--bs-form-invalid-border-color)" : ""}`}
                                            focusBorderColor={`${formState.errors.numChasis ? "var(--bs-form-invalid-border-color)" : "#2c7dfd"}`}
                                        />
                                    </div>
                                )}
                            />
                            {/* <SegInput label='N° de chasis' name='numChasis' type='text' width={100} /> */}
                        </div>

                        {mostrarGnc ?
                            <>
                                <div className="col-12 mt-3">
                                    <div className="fs-16 fw-bold text-primary">Datos del GNC</div>
                                    <div className="fs-13 text-gray-aux">Los encontrás en la oblea de tu equipo.</div>
                                </div>
                        <div className="col-md-4">
                            <Controller
                                name="gncNumeroOblea"
                                control={control}
                                rules={{}}
                                render={({ field, fieldState }) => (
                                    <div>
                                        <label style={{ fontWeight: 'bold' }}>N° de oblea</label>
                                        <SegInput
                                            className='mt-2'
                                            placeHolder="Ej: 1234567"
                                            name="gncNumeroOblea"
                                            type="text"
                                            width={100}
                                            onChange={(e) => {
                                                field.onChange(e);
                                                setValue("gncNumeroOblea", e.target.value);
                                                trigger("gncNumeroOblea");
                                            }}
                                            label=""
                                            value={field.value}
                                            leyendaError={fieldState?.error?.message}
                                            borderColor={`${fieldState?.error ? "var(--bs-form-invalid-border-color)" : ""}`}
                                            focusBorderColor={`${fieldState?.error ? "var(--bs-form-invalid-border-color)" : "#2c7dfd"}`}
                                        />
                                    </div>
                                )}
                            />
                        </div>
                        <div className="col-md-4">
                            <Controller
                                name="gncVencimientoOblea"
                                control={control}
                                rules={{ validate: { vencimiento: (valor: string) => validarVencimientoOblea(valor) } }}
                                render={({ field, fieldState }) => (
                                    <div>
                                        <label style={{ fontWeight: 'bold' }}>Vencimiento de la oblea</label>
                                        <SegInput
                                            className='mt-2'
                                            placeHolder=""
                                            name="gncVencimientoOblea"
                                            type="date"
                                            width={100}
                                            onChange={(e) => {
                                                field.onChange(e);
                                                setValue("gncVencimientoOblea", e.target.value);
                                                trigger("gncVencimientoOblea");
                                            }}
                                            label=""
                                            value={field.value}
                                            leyendaError={fieldState?.error?.message}
                                            borderColor={`${fieldState?.error ? "var(--bs-form-invalid-border-color)" : ""}`}
                                            focusBorderColor={`${fieldState?.error ? "var(--bs-form-invalid-border-color)" : "#2c7dfd"}`}
                                        />
                                    </div>
                                )}
                            />
                        </div>
                        <div className="col-md-4">
                            <Controller
                                name="gncMarcaRegulador"
                                control={control}
                                rules={{}}
                                render={({ field, fieldState }) => (
                                    <div>
                                        <label style={{ fontWeight: 'bold' }}>Marca del regulador</label>
                                        <SegInput
                                            className='mt-2'
                                            placeHolder="Ej: Tomasetto"
                                            name="gncMarcaRegulador"
                                            type="text"
                                            width={100}
                                            onChange={(e) => {
                                                field.onChange(e);
                                                setValue("gncMarcaRegulador", e.target.value);
                                                trigger("gncMarcaRegulador");
                                            }}
                                            label=""
                                            value={field.value}
                                            leyendaError={fieldState?.error?.message}
                                            borderColor={`${fieldState?.error ? "var(--bs-form-invalid-border-color)" : ""}`}
                                            focusBorderColor={`${fieldState?.error ? "var(--bs-form-invalid-border-color)" : "#2c7dfd"}`}
                                        />
                                    </div>
                                )}
                            />
                        </div>
                        <div className="col-md-4">
                            <Controller
                                name="gncNumeroRegulador"
                                control={control}
                                rules={{}}
                                render={({ field, fieldState }) => (
                                    <div>
                                        <label style={{ fontWeight: 'bold' }}>N° del regulador</label>
                                        <SegInput
                                            className='mt-2'
                                            placeHolder="Ej: R-9"
                                            name="gncNumeroRegulador"
                                            type="text"
                                            width={100}
                                            onChange={(e) => {
                                                field.onChange(e);
                                                setValue("gncNumeroRegulador", e.target.value);
                                                trigger("gncNumeroRegulador");
                                            }}
                                            label=""
                                            value={field.value}
                                            leyendaError={fieldState?.error?.message}
                                            borderColor={`${fieldState?.error ? "var(--bs-form-invalid-border-color)" : ""}`}
                                            focusBorderColor={`${fieldState?.error ? "var(--bs-form-invalid-border-color)" : "#2c7dfd"}`}
                                        />
                                    </div>
                                )}
                            />
                        </div>
                                {CILINDROS.map((cilindro) => (
                                    <div className="col-md-4" key={cilindro.marca}>
                                        <label style={{ fontWeight: 'bold' }}>Cilindro {cilindro.etiqueta}</label>
                                        <div className="d-flex" style={{ gap: "8px" }}>
                                            <Controller
                                                name={cilindro.marca}
                                                control={control}
                                                render={({ field }) => (
                                                    <SegInput
                                                        className='mt-2'
                                                        placeHolder="Marca"
                                                        name={cilindro.marca}
                                                        type="text"
                                                        width={100}
                                                        onChange={(e) => {
                                                            field.onChange(e);
                                                            setValue(cilindro.marca, e.target.value);
                                                        }}
                                                        label=""
                                                        value={field.value}
                                                    />
                                                )}
                                            />
                                            <Controller
                                                name={cilindro.numero}
                                                control={control}
                                                render={({ field }) => (
                                                    <SegInput
                                                        className='mt-2'
                                                        placeHolder="Número"
                                                        name={cilindro.numero}
                                                        type="text"
                                                        width={100}
                                                        onChange={(e) => {
                                                            field.onChange(e);
                                                            setValue(cilindro.numero, e.target.value);
                                                        }}
                                                        label=""
                                                        value={field.value}
                                                    />
                                                )}
                                            />
                                        </div>
                                    </div>
                                ))}
                            </>
                            : <></>
                        }

                        {viaBff && tiposInspeccion.length > 0 ?
                            <>
                                <div className="col-12 mt-3">
                                    <div className="fs-16 fw-bold text-primary">Inspección del vehículo</div>
                                </div>
                                <div className="col-md-4">
                                    <label style={{ fontWeight: 'bold' }}>Tipo de inspección</label>
                                    <FormProvider {...selects}>
                                        <SegSelect
                                            name='tipoInspeccion'
                                            options={tiposInspeccion}
                                            selected={tipoInspeccion}
                                            setSelected={setTipoInspeccion}
                                            width={"100%"}
                                            className="w-100 mt-2" />
                                    </FormProvider>
                                </div>
                            </>
                            : <></>
                        }

                        {viaBff && inspeccionADomicilio ?
                            <>
                                <div className="col-12">
                                    <div className="fs-14 fw-bold text-primary">¿Dónde y cuándo hacemos la inspección?</div>
                                </div>
                                <div className="col-md-4">
                                    <label style={{ fontWeight: 'bold' }}>Provincia</label>
                                    <FormProvider {...selects}>
                                        <SegSelect
                                            name='provinciaInspeccion'
                                            options={provinciasInspeccion}
                                            selected={provinciaInspeccion}
                                            setSelected={setProvinciaInspeccion}
                                            width={"100%"}
                                            borderColor={provinciaInspeccion ? "" : "red"}
                                            className="w-100 mt-2" />
                                    </FormProvider>
                                </div>
                        <div className="col-md-4">
                            <Controller
                                name="inspDomLocalidad"
                                control={control}
                                rules={{ validate: { requerido: (valor: string) => !!(valor || '').trim() || "Ingresá la localidad" } }}
                                render={({ field, fieldState }) => (
                                    <div>
                                        <label style={{ fontWeight: 'bold' }}>Localidad</label>
                                        <SegInput
                                            className='mt-2'
                                            placeHolder="Ej: San Isidro"
                                            name="inspDomLocalidad"
                                            type="text"
                                            width={100}
                                            onChange={(e) => {
                                                field.onChange(e);
                                                setValue("inspDomLocalidad", e.target.value);
                                                trigger("inspDomLocalidad");
                                            }}
                                            label=""
                                            value={field.value}
                                            leyendaError={fieldState?.error?.message}
                                            borderColor={`${fieldState?.error ? "var(--bs-form-invalid-border-color)" : ""}`}
                                            focusBorderColor={`${fieldState?.error ? "var(--bs-form-invalid-border-color)" : "#2c7dfd"}`}
                                        />
                                    </div>
                                )}
                            />
                        </div>
                        <div className="col-md-4">
                            <Controller
                                name="inspDomCodigoPostal"
                                control={control}
                                rules={{ validate: { requerido: (valor: string) => /^\\d{4}$/.test((valor || '').trim()) || "Ingresá un código postal de 4 dígitos" } }}
                                render={({ field, fieldState }) => (
                                    <div>
                                        <label style={{ fontWeight: 'bold' }}>Código postal</label>
                                        <SegInput
                                            className='mt-2'
                                            placeHolder="Ej: 1642"
                                            name="inspDomCodigoPostal"
                                            type="text"
                                            width={100}
                                            onChange={(e) => {
                                                field.onChange(e);
                                                setValue("inspDomCodigoPostal", e.target.value);
                                                trigger("inspDomCodigoPostal");
                                            }}
                                            label=""
                                            value={field.value}
                                            leyendaError={fieldState?.error?.message}
                                            borderColor={`${fieldState?.error ? "var(--bs-form-invalid-border-color)" : ""}`}
                                            focusBorderColor={`${fieldState?.error ? "var(--bs-form-invalid-border-color)" : "#2c7dfd"}`}
                                        />
                                    </div>
                                )}
                            />
                        </div>
                        <div className="col-md-4">
                            <Controller
                                name="inspDomCalle"
                                control={control}
                                rules={{ validate: { requerido: (valor: string) => !!(valor || '').trim() || "Ingresá la calle" } }}
                                render={({ field, fieldState }) => (
                                    <div>
                                        <label style={{ fontWeight: 'bold' }}>Calle</label>
                                        <SegInput
                                            className='mt-2'
                                            placeHolder="Ej: Av. Libertador"
                                            name="inspDomCalle"
                                            type="text"
                                            width={100}
                                            onChange={(e) => {
                                                field.onChange(e);
                                                setValue("inspDomCalle", e.target.value);
                                                trigger("inspDomCalle");
                                            }}
                                            label=""
                                            value={field.value}
                                            leyendaError={fieldState?.error?.message}
                                            borderColor={`${fieldState?.error ? "var(--bs-form-invalid-border-color)" : ""}`}
                                            focusBorderColor={`${fieldState?.error ? "var(--bs-form-invalid-border-color)" : "#2c7dfd"}`}
                                        />
                                    </div>
                                )}
                            />
                        </div>
                        <div className="col-md-4">
                            <Controller
                                name="inspDomAltura"
                                control={control}
                                rules={{ validate: { requerido: (valor: string) => !!(valor || '').trim() || "Ingresá la altura" } }}
                                render={({ field, fieldState }) => (
                                    <div>
                                        <label style={{ fontWeight: 'bold' }}>Altura</label>
                                        <SegInput
                                            className='mt-2'
                                            placeHolder="Ej: 1500"
                                            name="inspDomAltura"
                                            type="text"
                                            width={100}
                                            onChange={(e) => {
                                                field.onChange(e);
                                                setValue("inspDomAltura", e.target.value);
                                                trigger("inspDomAltura");
                                            }}
                                            label=""
                                            value={field.value}
                                            leyendaError={fieldState?.error?.message}
                                            borderColor={`${fieldState?.error ? "var(--bs-form-invalid-border-color)" : ""}`}
                                            focusBorderColor={`${fieldState?.error ? "var(--bs-form-invalid-border-color)" : "#2c7dfd"}`}
                                        />
                                    </div>
                                )}
                            />
                        </div>
                        <div className="col-md-4">
                            <Controller
                                name="inspDomFecha"
                                control={control}
                                rules={{}}
                                render={({ field, fieldState }) => (
                                    <div>
                                        <label style={{ fontWeight: 'bold' }}>Fecha</label>
                                        <SegInput
                                            className='mt-2'
                                            placeHolder=""
                                            name="inspDomFecha"
                                            type="date"
                                            width={100}
                                            onChange={(e) => {
                                                field.onChange(e);
                                                setValue("inspDomFecha", e.target.value);
                                                trigger("inspDomFecha");
                                            }}
                                            label=""
                                            value={field.value}
                                            leyendaError={fieldState?.error?.message}
                                            borderColor={`${fieldState?.error ? "var(--bs-form-invalid-border-color)" : ""}`}
                                            focusBorderColor={`${fieldState?.error ? "var(--bs-form-invalid-border-color)" : "#2c7dfd"}`}
                                        />
                                    </div>
                                )}
                            />
                        </div>
                        <div className="col-md-4">
                            <Controller
                                name="inspDomHorarioDesde"
                                control={control}
                                rules={{}}
                                render={({ field, fieldState }) => (
                                    <div>
                                        <label style={{ fontWeight: 'bold' }}>Desde</label>
                                        <SegInput
                                            className='mt-2'
                                            placeHolder=""
                                            name="inspDomHorarioDesde"
                                            type="time"
                                            width={100}
                                            onChange={(e) => {
                                                field.onChange(e);
                                                setValue("inspDomHorarioDesde", e.target.value);
                                                trigger("inspDomHorarioDesde");
                                            }}
                                            label=""
                                            value={field.value}
                                            leyendaError={fieldState?.error?.message}
                                            borderColor={`${fieldState?.error ? "var(--bs-form-invalid-border-color)" : ""}`}
                                            focusBorderColor={`${fieldState?.error ? "var(--bs-form-invalid-border-color)" : "#2c7dfd"}`}
                                        />
                                    </div>
                                )}
                            />
                        </div>
                        <div className="col-md-4">
                            <Controller
                                name="inspDomHorarioHasta"
                                control={control}
                                rules={{}}
                                render={({ field, fieldState }) => (
                                    <div>
                                        <label style={{ fontWeight: 'bold' }}>Hasta</label>
                                        <SegInput
                                            className='mt-2'
                                            placeHolder=""
                                            name="inspDomHorarioHasta"
                                            type="time"
                                            width={100}
                                            onChange={(e) => {
                                                field.onChange(e);
                                                setValue("inspDomHorarioHasta", e.target.value);
                                                trigger("inspDomHorarioHasta");
                                            }}
                                            label=""
                                            value={field.value}
                                            leyendaError={fieldState?.error?.message}
                                            borderColor={`${fieldState?.error ? "var(--bs-form-invalid-border-color)" : ""}`}
                                            focusBorderColor={`${fieldState?.error ? "var(--bs-form-invalid-border-color)" : "#2c7dfd"}`}
                                        />
                                    </div>
                                )}
                            />
                        </div>
                        <div className="col-md-4">
                            <Controller
                                name="inspDomCodigoArea"
                                control={control}
                                rules={{}}
                                render={({ field, fieldState }) => (
                                    <div>
                                        <label style={{ fontWeight: 'bold' }}>Cód. de área</label>
                                        <SegInput
                                            className='mt-2'
                                            placeHolder="Ej: 11"
                                            name="inspDomCodigoArea"
                                            type="text"
                                            width={100}
                                            onChange={(e) => {
                                                field.onChange(e);
                                                setValue("inspDomCodigoArea", e.target.value);
                                                trigger("inspDomCodigoArea");
                                            }}
                                            label=""
                                            value={field.value}
                                            leyendaError={fieldState?.error?.message}
                                            borderColor={`${fieldState?.error ? "var(--bs-form-invalid-border-color)" : ""}`}
                                            focusBorderColor={`${fieldState?.error ? "var(--bs-form-invalid-border-color)" : "#2c7dfd"}`}
                                        />
                                    </div>
                                )}
                            />
                        </div>
                        <div className="col-md-4">
                            <Controller
                                name="inspDomTelefono"
                                control={control}
                                rules={{}}
                                render={({ field, fieldState }) => (
                                    <div>
                                        <label style={{ fontWeight: 'bold' }}>Teléfono</label>
                                        <SegInput
                                            className='mt-2'
                                            placeHolder="Ej: 40404040"
                                            name="inspDomTelefono"
                                            type="text"
                                            width={100}
                                            onChange={(e) => {
                                                field.onChange(e);
                                                setValue("inspDomTelefono", e.target.value);
                                                trigger("inspDomTelefono");
                                            }}
                                            label=""
                                            value={field.value}
                                            leyendaError={fieldState?.error?.message}
                                            borderColor={`${fieldState?.error ? "var(--bs-form-invalid-border-color)" : ""}`}
                                            focusBorderColor={`${fieldState?.error ? "var(--bs-form-invalid-border-color)" : "#2c7dfd"}`}
                                        />
                                    </div>
                                )}
                            />
                        </div>
                            </>
                            : <></>
                        }

                        <div style={(window.innerWidth > 768) ? { display: "grid", gridTemplateColumns: "80% 20%", alignItems: "end" } : {}}>
                            {renderInputCertificadoNoRodamiento()}
                            <div className={`d-flex align-items-end mt-3 ${window.innerWidth < 768 ? 'justify-content-center' : 'justify-content-end'}`}>
                                <div style={window.innerWidth < 768 ? { width: "100%" } : {}}>
                                    <RechazoEmbudo mensaje={rechazoEmbudo} />
                                    <SegButton label='Continuar'
                                        type='submit' disabled={!formState.isValid || validarCNR()}
                                        className={`${window.innerWidth > 768 && "fs-15"}`}
                                        style={{ width: window.innerWidth < 768 ? "100%" : "" }} 
                                        loading={isLoading}
                                        />
                                    <div className="text-center" style={{ paddingTop: "5px" }}>
                                        <a href={encodeURI("https://wa.me/5491128357048?text=Hola, necesito ayuda con la emisión de mi seguro " + (emisionValues?.cotizacionDesc?.planName! || null) + " de la aseguradora " + (emisionValues?.cotizacionDesc?.companyName! || null) + ". Quiero hablar con un asesor.")} target='_blank' rel='noreferrer' className="fs-14 fw-medium fs-md-17 a-dark">
                                            <span className="hover-border-underline">Continuar por WhatsApp</span>
                                            <svg className="icon" style={{ width: 20, height: 20, marginLeft: 5, verticalAlign: "middle" }}><use xlinkHref="#whatsapp"></use></svg>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>



                        {/* <div className="col-md-4">
                                <div className="d-flex align-items-center">
                                <div className="me-3 mb-1">
                                <svg className="icon" width="23" height="29"><use xlinkHref="#lock"></use></svg>
                                </div>
                                <div className="fs-13 lh-sm">
                                <b>Pago 100% seguro</b> con todas las tarjetas de crédito
                                </div>
                                </div>
                            </div> */}
                    </SegFormEmisionContainer>
                </form>
            </div>
        </div>
    )
}